import { Injectable } from '@angular/core';
import { PCacheable } from 'ts-cacheable';
import { environment } from '../../environments/environment';
import { ApiService } from '../../shared/services/api.service';
import { DisplayLabel } from '../models/displayLabel';

@Injectable({
  providedIn: 'root',
})
export class AreaService {
  constructor(private api: ApiService) {}

  @PCacheable()
  public async findAllClisAndCtms(except: boolean = false): Promise<[DisplayLabel[], DisplayLabel[]]> {
    const url: string = environment.api.areas + '/areaType' + (except ? '?except=true' : '');
    return this.api.get<[DisplayLabel[], DisplayLabel[]]>(url);
  }
  @PCacheable()
  public async findAllClis(except: boolean = false): Promise<DisplayLabel[]> {
    const url: string = environment.api.areas + '/clis' + (except ? '?except=true' : '');
    return this.api.get<DisplayLabel[]>(url);
  }
  @PCacheable()
  public async findAllCtms(): Promise<DisplayLabel[]> {
    return this.api.get<DisplayLabel[]>(environment.api.areas + '/ctms');
  }
}
